import { PLAY_SOUND, STOP_SOUND } from '../constants';

const soundsReducer = (state, action) => {
  const defaultState = {
    sounds: {},
  };
  if (!state) {
    state = defaultState;
  }

  const out = { ...state.sounds };
  const id = action.data;

  switch (action.type) {
    case PLAY_SOUND:
      if (out[id]) {
        return state;
      }
      out[id] = id;
      return {
        sounds: out,
      };

    case STOP_SOUND:
      if (out[id]) {
        delete out[id];
      }
      return {
        sounds: out,
      };
    default:
      return state;
  }
};

export default soundsReducer;
